<div class="filterParent">
  <button #toggleButton type="button" (click)="onFilterClick($event)" class="btn btn-default btn-sm"
    [ngClass]="isFilterActive ? 'btn-info btn-fill' : ''" type="button">
    {{ buttonText }}
    <span #caret class="caret"></span>
  </button>
  <div #filterDropdown *ngIf="isFilterOpened" class="filterContainer card" aria-labelledby="dropdownMenu1"
    (keydown.enter)="onDoneClick()">
    <div class="header">
      <div>
        <button type="button" class="btn btn-default btn-fill btn-sm" *ngIf="filter.canClear" (click)="onClearClick()">
          Clear
        </button>
      </div>
      <div>Filters</div>
      <div>
        <input type="button" class="btn btn-info btn-fill btn-sm" (click)="onDoneClick()" value="Done" />
      </div>
    </div>
    <app-filter-element *ngFor="let filterElement of filter.parameters" [filterElementParameter]="filterElement">
    </app-filter-element>
  </div>
</div>